module.exports = __webpack_public_path__ + "static/media/DSC09712.88b29315.jpg";